import React from 'react';
import './home.css';

const HomePage = () => (
	<div className="Homepage">
		<img
			src="https://cef-interstat.eu/wp-content/uploads/2020/12/INTERSTAT_Symbol.png"
			//className="App-logo"
			alt="logo"
		/>
		<p>INTERSTAT Geolocalized Facilities pilot application</p>
		<a
			className="Framework-link"
			href="https://framework.cef-interstat.eu/"
			target="_blank"
			rel="noopener noreferrer"
		>
			INTERSTAT Framework homepage
		</a>

		<div className="Description">
		<br/>
		<br/>
		<br/>

		<br/>The main objective of the “Geolocalize Facilities” (GF) pilot is to set up a mechanism for the dissemination and use of information 
		<br/>about <b>facilities or equipment</b> so that the information is contextualized in space and can be integrated with other sources of data. 
		<br/>Here, the term “facilities” (or “equipment”) corresponds to points of services, merchant, or not, which are accessible to the public 
		<br/>and operate in domains like <b>education, health, social services, transport, sports, leisure, culture, or tourism</b>.
		<br/>
		<br/>The main data sources analyzed for this use case are:

		<div class="SubDescription">
		<br/>		● <b>Italian Census data</b>: data of the Census of Population and Housing aggregated at different territorial levels produced by ISTAT
		<br/>		● <b>French Census data</b>: data of the Census of Population and Housing aggregated at different territorial levels produced by Insee
		<br/>		● <b>Italian education facilities:</b> subset of datasets extracted from the catalogue published by the Italian Ministry for Education (MIUR)
		<br/>		● <b>Italian museums and cultural events:</b> data extracted from the MiBACT SPARQL endpoint of the MiBACT Open catalogue database
		<br/>		<t>published by Italian Ministry of Cultural Heritage and Activities (MIBACT)</t>
		<br/>		● <b>French facilities: </b> BPE, Permanent database of facilities, published by Insee
		</div>

		<br/>In this use case, Italian data concerning school attendance was retrieved via API, by accessing and querying the publisher website in real time.

		</div>


	</div>
);

export default HomePage;
